'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import dynamic from 'next/dynamic';

const BuilderPage = dynamic(() => import('@/components/builder/BuilderPage'), {
  ssr: false,
  loading: () => (
    <div className="flex-1 flex items-center justify-center bg-muted/30 min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0068D6] mx-auto mb-4"></div>
        <p className="text-muted-foreground">Loading builder...</p>
      </div>
    </div>
  ),
});

interface BuilderOverlayInnerProps {
  brand: { name: string; slug: string; logo?: string };
}

function BuilderOverlayInner({ brand }: BuilderOverlayInnerProps) {
  const searchParams = useSearchParams();
  const isBuilder = searchParams.has('builder');

  if (!isBuilder) return null;

  return (
    <div className="builder-overlay-fixed">
      <BuilderPage brandName={brand.name} brandLogo={brand.logo} brandSlug={brand.slug} />
    </div>
  );
}

interface BuilderSwitchProps {
  brand: { name: string; slug: string; logo?: string };
}

export default function BuilderSwitch({ brand }: BuilderSwitchProps) {
  return (
    <Suspense fallback={null}>
      <BuilderOverlayInner brand={brand} />
    </Suspense>
  );
}
